import React from "react";
import { Link } from "../i18n/LangContext";
import { useTranslation } from "react-i18next";
import "../styles/ThankYou.css"; // Import the new CSS file
import Seo from "../seo/Seo";

const ThankYou = () => {
  const { t } = useTranslation();
  return (
    <section className="thank_you_section">
      <Seo page="thankYou" path="/thank-you" override={{ noindex: true }} />
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-md-10 text-center">
            <div className="heading_container d-flex justify-content-center">
              <h2>{t("thankYou.title")}</h2>
            </div>
            <p className="text-muted mt-4">
              {t("thankYou.text")}
            </p>
            <p className="mt-5">
              <Link to="/" className="btn btn-primary px-4 py-2 me-3">
                {t("thankYou.home")}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThankYou;
